import { Alert, Button, Checkbox, Form, Table } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { constants } from "../../constants/common";
import { getData } from "../../actions/apiCall";
import { decryptData } from "../../actions/crypto";
const { useForm } = Form;

const Instructions = () => {
    const { id } = useParams();
    const [form] = useForm();
    const sectionRefs = useRef([]);
    const [testDetails, setTestDetails] = useState(null);
    const [tableData, setTableData] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [validtest, setValidTest] = useState(false);

    const handleContinue = (index) => {
        if (index <= sectionRefs.current.length - 1) {
            sectionRefs.current[index]?.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };

    useEffect(() => {
        if (testDetails) {
            console.log(testDetails);
            const mcqs = testDetails?.mcqQuestions?.map((item, index) => {
                return {
                    key: index + 1,
                    number: index + 1,
                    questionType: "MCQ's",
                    section: item.section,
                    questions: item.questionCount,
                    time: item.timeRequired + " Min"
                }
            }) || [];
            const aiInterview = testDetails?.aiInterviewConfig?.map((item, index) => {
                return {
                    key: mcqs.length + index + 1,
                    number: mcqs.length + index + 1,
                    questionType: "AI Round",
                    section: item.section || item.sectionId?.name || "AI Interview",
                    questions: item.questionCount,
                    time: item.timeRequired + " Min"
                }
            }) || [];
            const coding = testDetails?.coddingQuestions?.map((item, index) => {
                return {
                    key: mcqs.length + aiInterview.length + index + 1,
                    number: mcqs.length + aiInterview.length + index + 1,
                    questionType: "Code",
                    section: item.section,
                    questions: item.questionCount,
                    time: item.timeRequired + " Min"
                }
            }) || [];

            const data = [
                ...mcqs,
                ...aiInterview,
                ...coding
            ];
            setTableData(data);
        }
    }, [testDetails]);

    useEffect(() => {
        if (id) {
            getTestDetails();
        }
    }, [id]);

    const status = {
        "setup-in-progress": {
            "message": "Setting up your test",
            "description": "We are preparing your test environment. Please wait while we finish the setup.",
            "alertType": "info"
        },
        "completed": {
            "message": "Test completed",
            "description": "Your test has been successfully completed. You can wait for further instructions.",
            "alertType": "success"
        },
        "expired": {
            "message": "Test expired",
            "description": "Your test session has expired due to inactivity or time limit. Please request a new session.",
            "alertType": "warning"
        },
        "inporgress": {
            "message": "Test in progress",
            "description": "Your test is currently in progress. Please do not close the window or navigate away.",
            "alertType": "info"
        },
        "failed": {
            "message": "Test failed",
            "description": "Your test could not be completed due to a system or network error. Please try again or contact support.",
            "alertType": "error"
        }
    }


    const getTestDetails = async () => {
        try {
            const resData = await dispatch(getData(`/accel-test/${id}`));
            if (resData.code === 200) {
                const data = decryptData(resData.data)
                setTestDetails(data);
                if (data?.testStatus === 'completed') {
                    setValidTest(false);
                    return;
                }

                if (data?.testStatus === 'expired') {
                    setValidTest(false);
                    return;
                }

                if (data?.testStatus === 'cancelled') {
                    setValidTest(false);
                    return;
                }

                setValidTest(true);

            } else {
                console.log(resData);
            }
        } catch (error) {
            console.log(error);
            setValidTest(false);
        }
    }

    const onSubmit = () => {
        if (validtest) {
            navigate(`/online-exam/${id}/system-check`);
        }
    }

    return (
        <div className="flex h-screen">
            <div className="w-1/3 bg-gray-50 flex flex-col justify-center p-10">
                {status[testDetails?.testStatus] && <div className="mb-5">
                    <Alert type={status[testDetails?.testStatus].alertType}
                        message={status[testDetails?.testStatus].message}
                        description={status[testDetails?.testStatus].description}
                    />
                </div>}
                <h2 className="text-gray-500">Hey {testDetails?.candidate?.firstName}</h2>
                <h1 className="text-2xl font-bold">Welcome to Accelgrowth Technology</h1>
                <h2 className="text-xl font-bold">{testDetails?.name}</h2>
                <div className="flex flex-rows mt-5 space-x-5 flex-wrap">
                    <div className="mt-5">
                        <p className="text-gray-600">Test Duration</p>
                        <p className="font-semibold">{testDetails?.totalTimeRequired} Min</p>
                    </div>
                    {testDetails?.totalMCQQuestions > 0 && (
                        <div className="mt-5">
                            <p className="text-gray-600">Total MCQ</p>
                            <p className="font-semibold">{testDetails?.totalMCQQuestions} Questions</p>
                        </div>
                    )}
                    {testDetails?.totalCodingQuestions > 0 && (
                        <div className="mt-5">
                            <p className="text-gray-600">Total Codding Questions</p>
                            <p className="font-semibold">{testDetails?.totalCodingQuestions} Questions</p>
                        </div>
                    )}
                    {testDetails?.aiInterviewConfig && testDetails?.aiInterviewConfig.length > 0 && (() => {
                        const totalAIQuestions = testDetails.totalAIInterviewQuestions ||
                            testDetails.aiInterviewConfig.reduce((acc, item) => acc + (item.questionCount || 0), 0);
                        const totalAITime = testDetails.aiInterviewConfig.reduce((acc, item) => acc + (item.timeRequired || 0), 0);
                        return (
                            <div className="mt-5">
                                <p className="text-gray-600">AI Round</p>
                                <p className="font-semibold">{totalAIQuestions} Questions ({totalAITime} Min)</p>
                            </div>
                        );
                    })()}
                </div>
            </div>

            <div className="w-2/3 bg-[#F3F7F7] p-10 flex flex-col relative h-full overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">

                <div className="mb-100 mt-20"
                    key={'Instructions'}
                    ref={(el) => (sectionRefs.current[0] = el)}
                >
                    <h2 className="text-3xl font-semibold">Instructions</h2>
                    <ul className="list-disc pl-5 mt-2 text-black w-2/3 text-md leading-relaxed">
                        <li>This is a timed test. Once started, the timer will not stop under any circumstances.</li>
                        <li>Ensure you have a stable internet connection before beginning.</li>
                        <li>You cannot pause or restart the test once it begins.</li>
                        <li>Submissions after the timer expires will not be accepted.</li>
                        <li><strong>Answer Carefully - </strong> Once you submit an answer, you may not be able to go back and change it. Read each question carefully before selecting or submitting your response.</li>
                        <li><strong>Stay Focused -</strong> Navigating away from the test window may result in automatic submission or penalties. Ensure you remain on the test screen throughout the duration.</li>
                        <li><strong>Use Approved Resources Only -</strong> Do not use any unauthorized tools, books, or external help while taking the test. Any attempt to cheat will lead to disqualification.</li>
                        <li><strong>Check System Requirements -</strong> Ensure your browser is up to date and disable any browser extensions that may interfere with the test platform.</li>
                        <li><strong>Time Management -</strong> Keep an eye on the timer and pace yourself accordingly to attempt all questions within the allotted time.</li>
                        <li><strong>Stable Power & Internet -</strong> In case of power or internet failure, the test may not be resumed. Use a reliable connection to prevent disconnections.</li>
                        <li><strong>Submit Before Time Ends -</strong> Your answers will be auto-submitted when time runs out, even if you haven’t completed all questions.</li>
                        <li><strong>Follow Test Guidelines -</strong> Any violation of test rules may result in termination of your test attempt or invalidation of results.</li>
                        <li><strong>Read Question Format - </strong>Some questions may have multiple correct answers, while others may require coding solutions or written explanations. Pay close attention to instructions.</li>
                        <li><strong>Ensure Code Compilation -</strong> If the test includes coding challenges, make sure your code compiles and runs successfully before submission.</li>
                    </ul>
                    <Button type="primary" className="mt-4" onClick={() => handleContinue(1)}>
                        Continue
                    </Button>
                </div>

                <div className="mb-100 mt-100"
                    key={'Sections'}
                    ref={(el) => (sectionRefs.current[1] = el)}
                >
                    <h2 className="text-3xl font-semibold">Sections</h2>
                    <Table
                        className="mt-4 w-2/3"
                        columns={[
                            { title: "Sr.No.", dataIndex: "number", key: "number", align: "center" },
                            { title: "Sections", dataIndex: "section", key: "section" },
                            { title: "Question Type", dataIndex: "questionType", key: "questionType", align: "center" },
                            { title: "Questions", dataIndex: "questions", key: "questions", align: "center" },
                            { title: "Time Required", dataIndex: "time", key: "time", align: "center" }
                        ]}
                        dataSource={tableData}
                        pagination={false}
                    />
                    <Button type="primary" className="mt-4" onClick={() => handleContinue(2)}>
                        Continue
                    </Button>
                </div>

                <div className="mb-100 mt-100"
                    key={'Confirmation'}
                    ref={(el) => (sectionRefs.current[2] = el)}
                >
                    <h2 className="text-3xl font-semibold">Confirmation</h2>
                    <div className="leading-relaxed mt-4">
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={() => onSubmit()}
                        >
                            <Form.Item
                                valuePropName="checked"
                                rules={[{ required: true, message: 'Please confirm the statement' }]}
                                name={'confirmation'}
                            >
                                <Checkbox>I confirm that all code submitted will be my original work and that I will not copy
                                    from any external sources, AI-generated tools, or other candidates.</Checkbox>
                            </Form.Item>
                            <Form.Item
                                valuePropName="checked"
                                name={'Iunderstand'}
                                rules={[{ required: true, message: 'Please confirm the statement' }]}
                            >
                                <Checkbox>I understand that this is a timed test, and the countdown will not stop once it begins.</Checkbox>
                            </Form.Item>
                        </Form>
                    </div>

                    <Button type="primary" className="mt-4" onClick={() => form.submit()} disabled={!validtest}>
                        Start Test
                    </Button>
                </div>
            </div>
        </div >
    )
}

export default Instructions;